$(() => {
  $('[data-behavior~=advice_cla_checkbox]').change((e) =>
    $('[data-behavior~=advice_cla_submit]').prop('disabled', !e.currentTarget.checked)
  )
})
